// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { List } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconList(props: any) {
    return <IconBase icon={List} {...props} />
  }

  export default IconList
  